import { Injectable } from '@angular/core';
import { CanActivate } from '@angular/router';
import { AccountService } from '../../shared/services/account.service';
import { Observable } from 'rxjs/Rx';
import { concatMap, map, take } from 'rxjs/operators';
import { AuthService } from '@yotpo-ui/core';
import { of } from 'rxjs';


@Injectable()
export class ProductGuard implements CanActivate {

  constructor(
    private accountService: AccountService,
    private authService: AuthService,
  ) { }

  canActivate(): Observable<boolean> {
    return this.authService.isAuthenticatedAsync().pipe(
      concatMap(isAuthenticated => {
        if (isAuthenticated) {
          return this.hasAppDomain();
        } else {
          return of(false);
        }
      })
    );
  }

  private hasAppDomain(): Observable<boolean> {
    return this.accountService.getAppData().pipe(take(1), map(
      (response) => {
        if (response.response.app.domain !== null) {
          return true;
        } else {
          return false;
        }
      }));
  }
}
